import React from 'react'

import CreditPayment from '../components/credit-payment'

class CreditPaymentPage extends React.Component{

	render(){
		return (
			<div style={{ margin: 16 }}>
				<CreditPayment />
			</div>
		)
	}

}

export default CreditPaymentPage;


// WEBPACK FOOTER //
// ./src/containers/credit-payment-page.js